import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import { Palette, Sun, Moon, Check } from 'lucide-react';

import s from './ThemeCustomizerCard.css';

// Theme accent color options
const ACCENT_COLORS = [
  { id: 'blue', label: 'Azul', color: '#3B82F6' },
  { id: 'red', label: 'Rojo', color: '#EF4444' },
  { id: 'green', label: 'Verde', color: '#10B981' },
  { id: 'yellow', label: 'Amarillo', color: '#F59E0B' },
  { id: 'gray', label: 'Flat', color: '#6B7280' },
  { id: 'purple', label: 'Morado', color: '#8B5CF6' },
];

class ThemeCustomizerCard extends Component {
  static propTypes = {
    className: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      accent: 'blue',
      theme: 'light',
    };
  }

  componentDidMount() {
    // Load saved preferences from localStorage
    if (typeof window !== 'undefined') {
      const savedAccent = localStorage.getItem('adminAccent') || 'blue';
      const savedTheme = localStorage.getItem('adminTheme') || 'light';
      
      this.setState({ accent: savedAccent, theme: savedTheme });
      this.applyTheme(savedTheme, savedAccent);
    }
  }

  applyTheme = (theme, accent) => {
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('data-admin-theme', theme);
      document.documentElement.setAttribute('data-admin-accent', accent);
    }
  };

  handleAccentChange = (accentId) => {
    this.setState({ accent: accentId });
    
    if (typeof window !== 'undefined') {
      localStorage.setItem('adminAccent', accentId);
    }
    
    this.applyTheme(this.state.theme, accentId);
  };

  handleThemeToggle = () => {
    const newTheme = this.state.theme === 'light' ? 'dark' : 'light';
    this.setState({ theme: newTheme });
    
    if (typeof window !== 'undefined') {
      localStorage.setItem('adminTheme', newTheme);
    }
    
    this.applyTheme(newTheme, this.state.accent);
  };

  render() {
    const { accent, theme } = this.state;
    const isDark = theme === 'dark';

    return (
      <div className={s.card}>
        <div className={s.cardHeader}>
          <Palette size={20} className={s.headerIcon} />
          <h3 className={s.cardTitle}>Personalizar Tema</h3>
        </div>
        
        <div className={s.cardBody}>
          {/* Accent Color Section */}
          <div className={s.section}>
            <label className={s.sectionLabel}>Color de Acento</label>
            <div className={s.colorGrid}>
              {ACCENT_COLORS.map((color) => (
                <button
                  key={color.id}
                  type="button"
                  className={cx(s.colorBtn, { [s.colorBtnActive]: accent === color.id })}
                  style={{ '--swatch-color': color.color }}
                  onClick={() => this.handleAccentChange(color.id)}
                  title={color.label}
                >
                  <span className={s.colorSwatch}>
                    {accent === color.id && <Check size={14} className={s.checkIcon} />}
                  </span>
                  <span className={s.colorLabel}>{color.label}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Theme Mode Section */}
          <div className={s.section}>
            <label className={s.sectionLabel}>Modo de Interfaz</label>
            <div className={s.themeToggle}>
              <button
                type="button"
                className={cx(s.themeBtn, { [s.themeBtnActive]: !isDark })}
                onClick={() => !isDark || this.handleThemeToggle()}
              >
                <Sun size={18} />
                <span>Día</span>
              </button>
              <button
                type="button"
                className={cx(s.themeBtn, { [s.themeBtnActive]: isDark })}
                onClick={() => isDark || this.handleThemeToggle()}
              >
                <Moon size={18} />
                <span>Noche</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(ThemeCustomizerCard);
